export const newConsultationDialogStrings = {
  title: 'Nueva consulta',
  patientLabel: 'Paciente',
  searchPlaceholder: 'Buscar por nombre o cédula',
  locationLabel: 'Ubicación',
  locationPlaceholder: 'Seleccionar ubicación',
  submitButton: 'Iniciar consulta',
  cancelButton: 'Cancelar',
} as const
